import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

export const TicketBackOfficeDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.BackOffice} />
}
